import { useAccess } from "@/auth/AccessProvider";
import { routeKeyFromPathname } from "@/auth/permissions";
import { Spinner } from "@/components/ui";
import { Navigate, Outlet, useLocation } from "react-router-dom";

export function RequireRouteAccess() {
  const { loading, canAccess, defaultRoute } = useAccess();
  const location = useLocation();
  const routeKey = routeKeyFromPathname(location.pathname);

  if (loading) {
    return (
      <div className="flex min-h-dvh items-center justify-center bg-[var(--color-surface-muted)]">
        <Spinner label="Checking access…" />
      </div>
    );
  }

  if (routeKey && !canAccess(routeKey)) {
    return <Navigate to={defaultRoute} replace />;
  }

  return <Outlet />;
}
